import { IResponseBase } from 'src/types/response-base';
import {
  CREATE_SCENARIO,
  GET_PH_RECOMMENDATION_CONFIG,
  GET_SCENARIOS,
  GET_SCENARIO_NAMES,
  SAVE_AS_SCENARIO,
  SCENARIO_FILTERS,
  UPDATE_SCENARIO
} from 'src/constants';
import { axios, IControlField2 } from 'src/lib';
import { IFieldResponse } from 'src/lib/dynamic-forms/types/control-field.base';
import { Scenario } from '../types/scenario.model';
import { IScenarioState } from '../types/scenario-state.model';

export function createScenario(body: {
  name: string;
  description: string;
  user: number;
  source: number;
  filter_data: {
    field_name: string;
    field_values: string[];
    field_alias: string;
  }[];
  allowScenarioNameOverride: boolean;
  include_demand_transference: boolean;
  planner_included: boolean;
}) {
  return axios
    .post(`${CREATE_SCENARIO}${body.source}/`, {
      name: body.name,
      description: body.description,
      source: body.source,
      filter_data: JSON.stringify(body.filter_data),
      allowScenarioNameOverride: body.allowScenarioNameOverride,
      include_demand_transference: body.include_demand_transference,
      planner_included: body.planner_included
    })
    .then<IResponseBase<Scenario>>((response) => response.data);
}

export function updateScenario(body: {
  name: string;
  description: string;
  user: number;
  source: number;
  saveas_from: number;
  filter_data: {
    field_name: string;
    field_values: string[];
    field_alias: string;
  }[];
  allowScenarioNameOverride: boolean;
  include_demand_transference: boolean;
  planner_included: boolean;
}) {
  return axios
    .patch(`${UPDATE_SCENARIO}${body.source}/${body.saveas_from}/`, {
      name: body.name,
      description: body.description,
      source: body.source,
      filter_data: JSON.stringify(body.filter_data),
      allowScenarioNameOverride: body.allowScenarioNameOverride,
      include_demand_transference: body.include_demand_transference,
      planner_included: body.planner_included
    })
    .then<IResponseBase<Scenario>>((response) => response.data);
}

export function saveCopyOfScenario(body: {
  name: string;
  description: string;
  user: number;
  source: number;
  filter_data: {
    field_name: string;
    field_values: string[];
    field_alias: string;
  }[];
  is_saveas: boolean;
  is_duplicated: boolean;
  saveas_from: number;
  duplicate_from: number;
  allowScenarioNameOverride: boolean;
  include_demand_transference: boolean; 
  planner_included: boolean;
}) {
  return axios
    .post(`${SAVE_AS_SCENARIO}${body.source}/`, {
      name: body.name,
      description: body.description,
      filter_data: JSON.stringify(body.filter_data),
      source: body.source,
      saveas_from: body.saveas_from,
      is_duplicated: body.is_duplicated,
      is_saveas: body.is_saveas,
      duplicate_from: body.duplicate_from,
      allowScenarioNameOverride: body.allowScenarioNameOverride,
      include_demand_transference: body.include_demand_transference,
      planner_included: body.planner_included
    })
    .then<IResponseBase<Scenario>>((response) => response.data);
}

export function fetchScenarioList(body: { source_id: number }) {
  return axios
    .get(`${GET_SCENARIOS}${body.source_id}/`)
    .then<IResponseBase<Scenario[]>>((response) => response.data);
}

export function fetchScenarioNames(body: { sourceId: number }) {
  return axios
    .get(`${GET_SCENARIO_NAMES}${body.sourceId}/`)
    .then<IResponseBase<{ name: string; pk_id: number }[]>>(
      (response) => response.data
    );
}

export function fetchScenarioFilters(sourceId = 1, moduleId = 1) {
  return axios
    .get<{
      filters: IFieldResponse[];
      combinations: IScenarioState['scenarioFilters']['combinations'];
      ph_updated_at:{}
    }>(`${SCENARIO_FILTERS}${sourceId}/${moduleId}/`)
    .then((response) => {
      const filters = response.data.filters
        .slice()
        .sort(
          (filterA, filterB) =>
            filterA.placement_order - filterB.placement_order
        );
      return {
        filters,
        combinations: response.data.combinations,
        initialValues: {},
        ph_updated_at: response.data.ph_updated_at
      };
    });
}

export function fetchPhRecommendationConfig(source_id: number) {
  return axios
    .get(`${GET_PH_RECOMMENDATION_CONFIG}${source_id}/`)
    .then((response) => response.data);
}
